import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=83cfaeb4&"
import script from "./UpdateInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports